// src/pages/Gifthamper/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "../Collectionpage";
import { getGiftHampers, PRODUCTS_PER_PAGE } from "../../data/giftHampers";
import SEOHead from "../../components/common/SEOHead";
import ProductListSchema from "../../components/common/ProductListSchema";
import FAQSchema from "../../components/common/FAQSchema";

const PAGE_URL = "https://aishcraft.com/gift-hampers";

const giftHamperFAQs = [
  {
    question: "Are the gift hampers suitable for corporate gifting?",
    answer: "Yes, we offer curated corporate hampers perfect for teams, clients, and bulk corporate orders.",
  },
  {
    question: "Can I include a personalized message card?",
    answer: "Yes, every gift hamper includes an option to add a personalized message card for the recipient.",
  },
  {
    question: "How long does delivery take?",
    answer: "Gift hampers are curated to order and typically ship within 6 working days across India.",
  },
];

export default function Gifthamper() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getGiftHampers()
      .then(setProducts)
      .catch((err) => setError(err.message || "Failed to load products"));
  }, []);

  const seo = (
    <SEOHead
      title="Gift Hampers | Curated Personalized Hampers"
      description="Shop beautifully curated gift hampers for every occasion. Personalised message cards included, pan India delivery."
      url={PAGE_URL}
      breadcrumbs={[
        { name: "Home", item: "https://aishcraft.com/" },
        { name: "Gift Hampers", item: PAGE_URL },
      ]}
    />
  );

  if (error) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>
      </>
    );
  }

  if (!products) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>
      </>
    );
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/gift-hampers",
    announcement: {
      headline: "Gift someone something they'll actually love!",
      subtext: "Beautifully curated hampers • Personalised message cards included",
    },
    hero: {
      title: "Gift Hampers",
      subtitle: "Curated gifts for every occasion",
      featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "I ordered the corporate hamper for my team and everyone absolutely loved it — 10/10 would recommend.",
      quoteLink: "#",
      rating: "4.8",
      ratingCount: "500+",
    },
  };

  return (
    <>
      {seo}
      <ProductListSchema products={products} pageUrl={PAGE_URL} />
      <FAQSchema faqs={giftHamperFAQs} />
      <CollectionPage config={config} />
    </>
  );
}